import {
	createContext,
	useCallback,
	useContext,
	useMemo,
	useState,
} from 'react';
import { IntlProvider } from 'react-intl';
import { ErrorModal } from '../components/ErrorModal/ErrorModal';

import messagesEn from '../shared/i18n/translation/en.json';
import messagesAm from '../shared/i18n/translation/am.json';
import messagesRu from '../shared/i18n/translation/ru.json';

import { Language, LANGUAGE_KEY } from '../shared/consts/locale';

export const LocaleContext = createContext({
	handleSetLocale: locale => {},
	isErrorModalShow: null,
	setErrorModalShow: () => {},
});

const LocaleContextProvider = ({ children }) => {
	const [isErrorModalShow, setErrorModalShow] = useState(null);

	const [locale, setLocale] = useState(
		localStorage.getItem(LANGUAGE_KEY) ?? Language.En,
	);
	let messages;
	if (locale === Language.En) {
		messages = messagesEn;
	} else if (locale === Language.Ru) {
		messages = messagesRu;
	} else {
		messages = messagesAm;
	}

	const handleSetLocale = useCallback(locale => {
		setLocale(locale);
		localStorage.setItem(LANGUAGE_KEY, locale);
	}, []);

	const value = useMemo(
		() => ({
			handleSetLocale,
			isErrorModalShow,
			setErrorModalShow,
		}),
		[handleSetLocale, isErrorModalShow, setErrorModalShow],
	);

	return (
		<IntlProvider locale={locale} messages={messages}>
			<LocaleContext.Provider value={value}>
				{isErrorModalShow && (
					<ErrorModal
						setErrorModalShow={setErrorModalShow}
						isErrorModalShow={isErrorModalShow}
					/>
				)}
				{children}
			</LocaleContext.Provider>
		</IntlProvider>
	);
};

export function useLocale() {
	return useContext(LocaleContext);
}

export default LocaleContextProvider;
